import angular from "angular";
import _ from "underscore";
import resolve from "ioc/resolve";
import $appConfig from "servicestack/config";
import eventListener from "servicestack/event-listener";
import httpCodes from "webutils/http-codes";
import graphAppConfig from "emun.activity/graph-app.config";

class GraphHelper {
  static login() {
    return new GraphHelper().login();
  }
  static logout() {
    return new GraphHelper().logout();
  }
  static me() {
    return new GraphHelper().me();
  }
  static createEvent(event) {
    return new GraphHelper().createEvent(event);
  }
  static updateEvent(event) {
    return new GraphHelper().updateEvent(event);
  }
  static deleteEvent(event) {
    return new GraphHelper().deleteEvent(event);
  }
  static createSubscription() {
    return new GraphHelper().createSubscription();
  }
  static renewSubscription(id) {
    return new GraphHelper().renewSubscription(id);
  }
  constructor() {
    var me = this;
    //console.info("BL*** creatingApplication");
    me.clientApplication = new Msal.UserAgentApplication(
      graphAppConfig.clientID,
      null,
      function(errorDesc, token, error, tokenType) {
        // console.info(
        //   "BL*** after UserAgentApplication: outlook acquired token " + token
        // );
        if (token) {
          localStorage.token = token;
        }
        // Called after loginRedirect or acquireTokenPopup
      }
    );
  }

  login() {
    var me = this;
    console.info("BL*** calling loginPopup");
    me.clientApplication.loginPopup(graphAppConfig.graphScopes).then(
      function(idToken) {
        //console.info("BL*** calling acquireTokenSilent");
        me.clientApplication.acquireTokenPopup(graphAppConfig.graphScopes).then(
          function(accessToken) {
            localStorage.token = accessToken;
            // console.info(
            //   "BL*** acquireTokenPopup: outlook acquired token " +
            //     localStorage.token
            // );
            window.location.reload();
            me.createSubscription();
          },
          function(error) {
            window.alert("Error acquiring the popup:\n" + error);
          }
        );
      },
      function(error) {
        window.alert("Error during login:\n" + error);
      }
    );
  }
  logout() {
    var me = this;
    me.clientApplication.logout();
    delete localStorage.token;
    delete localStorage.user;
    delete localStorage.subscription;
  }
  // Get the profile of the current user.
  me() {
    return resolve("$http").get("https://graph.microsoft.com/v1.0/me");
  }
  createEvent(event) {
    return resolve("$http").post(
      "https://graph.microsoft.com/v1.0/me/calendar/events",
      event
    );
  }
  updateEvent(event) {
    return resolve("$http").patch(
      "https://graph.microsoft.com/v1.0/me/calendar/events/" + event.id,
      event
    );
  }
  deleteEvent(event) {
    return resolve("$http").delete(
      "https://graph.microsoft.com/v1.0/me/calendar/events/" + event.id
    );
  }
  createSubscription() {
    var guid = function() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    };
    var subscriptionId = guid();

    // console.info(
    //   "BL*** creating subscription with url = " +
    //     window.location.protocol +
    //     "//" +
    //     window.location.hostname +
    //     "/service/OutlookNotification"
    // );
    return resolve("$http")
      .post("https://graph.microsoft.com/v1.0/subscriptions/", {
        changeType: "created,updated",
        notificationUrl:
          "https://emun1.onecoast.com/service/OutlookNotification",
        resource: "me/events",
        //            "clientState": subscriptionId,
        expirationDateTime: "2017-12-28T00:00:00Z"
      })
      .then(function(response) {
        console.log(
          "BL*** createSubscription response " + JSON.stringify(response)
        );
        localStorage.subscription = subscriptionId;
      });
  }
  renewSubscription(id) {
    return resolve("$http").post(
      "https://graph.microsoft.com/v1.0/subscriptions/" + id
    );
  }
}

export default GraphHelper;
